




























































































import { Component, Vue } from 'vue-property-decorator';
import { i18n } from '@/i18n';
import { Getter } from 'vuex-class';
import { IPlace, IProductProperty, IProductType, IProperty, IWidget } from '@resclick/data-access';
import { compass } from '@resclick/compass';
import { date } from 'quasar';
import Flights from './flights.vue';
import formatDate = date.formatDate;

@Component({
  components: {
    Flights,
  },
})
export default class ExtrasStep extends Vue {
  @Getter('widget/property') property!: IProperty;
  @Getter('widget/additionalProducts')
  additionalProducts!: IWidget['additionalProducts'];
  @Getter('cart/products') products!: IProductType[];

  flightOffer = false;
  transferOffer = false;
  formatDate = formatDate;
  transferPackages = [];
  form = {
    fields: {
      transfer: {
        direction: 'ROUND_TRIP',
        code: '',
      },
      extra: [],
    },
  };
  isLoading = false;

  get offerOptions() {
    return [
      { label: i18n.t('GENERAL.NO_I_DONT_WANT'), value: false },
      { label: i18n.t('GENERAL.YES_I_WANT'), value: true },
    ];
  }

  get packages() {
    return [
      {
        name: 'Tam Masaj Seansı',
        image: 'https://media-cdn.tripadvisor.com/media/photo-s/08/f8/e1/06/cristal-erbil-hotel.jpg',
        description:
          'Bitki özlerinden elde edilmimş karışımlardan hazırlanan masaj yağlarını kullanılarak uygulanan bir masaj yöntemidir. Bu masajda dikkat edilen, temponun düşük ve hareketlerin şiddetinin hafif olmasıdır. ',
        price: '50.00 EUR',
        code: 'MASSAGE_TER',
      },
      {
        name: 'Yüz Masajı Seansı',
        image:
          'https://www.skincare.com/-/media/images/loreal/skincare/articles/featured-images/default/970-facial-massaging-techniques.jpg?h=575&la=en&w=970',
        description:
          'Yüz masajı, tam bir masaj seansı, tüm vücut masajının bir bölümü veya yüz tedavisinin bir bölümü olabilir. Yüz masajı profesyonel bir masaj terapisti, bir estetisyen veya bir güzellik uzmanı tarafından uygulanabilir.',
        price: '40.00 EUR',
        code: 'FACIAL_MASSAGE',
      },
      {
        name: 'Bira Tabağı',
        image:
          'https://scontent.fayt1-1.fna.fbcdn.net/v/t1.0-9/62422318_679382665816705_6568492944054026240_n.jpg?_nc_cat=110&ccb=2&_nc_sid=8bfeb9&_nc_ohc=j7E8wkJpaNYAX8t4DTT&_nc_ht=scontent.fayt1-1.fna&oh=d322f1972ef6e627e4c71eb888493ce4&oe=5FBB8050',
        description:
          'Sigara böreği, sosis, patates kızartması gibi pratik atıştırmalıklardan oluşur. Biranın yanında cips, çerez, patlamış mısır gibi atıştırmalıklarda hazırlanır.',
        price: '20.00 EUR',
        code: 'BEAR',
      },
      {
        name: 'Şampanya',
        description:
          'Tatilinizi veya özel gününüzü kutlamak için sizlere sunabileceğimzi geniş şampanya menümüz vardır.',
        image: 'https://usercontent.one/wp/www.kircicekleri.com/wp-content/uploads/2017/12/sampanya-678x381.jpg',
        price: '70.00 EUR',
        code: 'CHAMP',
      },
    ];
  }

  get travelDates() {
    const startDates = [];
    const endDates = [];
    const rooms: IProductProperty[] = this.products.filter((product) => product.productCategory === 'PROPERTY') as any;

    for (const room of rooms) {
      startDates.push(room.checkInDate);
      endDates.push(room.checkOutDate);
    }

    return {
      startDate: (date as any).getMinDate(...startDates),
      endDate: (date as any).getMaxDate(...endDates),
    };
  }

  get mockData() {
    return {
      transfers: [
        { name: 'Ekonomik Transfer', code: 'ECONOMIC', price: '700.00 TRY' },
        { name: 'Vip+ Transfer', code: 'VIP', price: '1300.00 TRY' },
      ],
    };
  }

  get transferOptions() {
    return [
      { label: i18n.t('GENERAL.FLIGHT'), value: 'FLIGHT' },
      { label: i18n.t('GENERAL.TRANSFER'), value: 'TRANSFER' },
    ];
  }

  get directionOptions() {
    return [
      { label: i18n.t('GENERAL.ROUND_TRIP'), value: 'ROUND_TRIP' },
      { label: i18n.t('GENERAL.DEPARTURE_ONLY'), value: 'DEPARTURE' },
      { label: i18n.t('GENERAL.RETURN_ONLY'), value: 'RETURN' },
    ];
  }

  onContinue() {
    this.$emit('changeStep', 2);
  }
}
